import { Suspense, useEffect, useState } from "react";

import { Outlet, useLocation } from "react-router-dom";

import CompanySettingsDialog from "features/Settings/CompanySettingsDialog";
import ExpiredSubscriptionDialog from "features/Settings/ExpiredSubscriptionDialog";
import ExpiringSubscriptionDialog from "features/Settings/ExpiringSubscriptionDialog";

import { useCompany } from "hooks/useCompany";

import { ROUTES } from "utils/constants";
import i18n from "utils/i18n";


import { useSubscriptionContext } from "context/Subscription";

export default function MainLayout() {
  const location = useLocation();

  const { company } = useCompany();
  const { subscription, isTrial, isActive } = useSubscriptionContext();

  const [companySettingsOpen, setCompanySettingsOpen] = useState<boolean>(false);
  const [expiringSubscriptionOpen, setExpiringSubscriptionOpen] = useState<boolean>(false);
  const [expiredSubscriptionOpen, setExpiredSubscriptionOpen] = useState<boolean>(false);

  const closeExpiringSubscriptionDialog = () => {
    sessionStorage.setItem("expiringSubscriptionSeen", "true");
    setExpiringSubscriptionOpen(false);
  };

  useEffect(() => {
    if (company && company.companySettings && company.companySettings.language) {
      localStorage.setItem("ui_locales", company.companySettings.language.code);
      i18n.changeLanguage(company.companySettings.language.code);
    }
    if (company && !company.companySettings) {
      i18n.changeLanguage(localStorage.getItem("ui_locales") || "bs");
      setCompanySettingsOpen(true);
    }
  }, [company]);

  useEffect(() => {
    if (subscription?.endDate) {
      const endDate = new Date(subscription.endDate);
      const now = new Date();
      const diffMs = endDate.getTime() - now.getTime();
      const diffHours = diffMs / (1000 * 60 * 60);

      const expiringSubscriptionSeen = sessionStorage.getItem("expiringSubscriptionSeen");

      if (diffHours > 0 && diffHours < 24 && !expiringSubscriptionSeen) {
        setExpiringSubscriptionOpen(true);
      }
    }
  }, [subscription]);

  useEffect(() => {
    if (subscription && !isActive && !location.pathname.includes(ROUTES.CHECKOUT)) {
      setExpiredSubscriptionOpen(true);
    }
  }, [subscription, isActive, location.pathname]);

  return (
    <div className="min-h-[100dvh] h-full">
      {company?.companySettings && (
        <main className="pt-16 min-h-[100dvh] relative flex flex-col h-full">
          <Suspense>
            <Outlet />
          </Suspense>
        </main>
      )}
      <CompanySettingsDialog isOpen={companySettingsOpen} setIsOpen={setCompanySettingsOpen} />
      <ExpiringSubscriptionDialog
        isOpen={expiringSubscriptionOpen}
        setIsOpen={setExpiringSubscriptionOpen}
        isTrial={isTrial}
        closeExpiringSubscriptionDialog={closeExpiringSubscriptionDialog}
      />
      <ExpiredSubscriptionDialog isOpen={expiredSubscriptionOpen} setIsOpen={setExpiredSubscriptionOpen} />
    </div>
  );
}
